import { render, staticRenderFns } from "./SettingsRoleEditView.vue?vue&type=template&id=ff992722&scoped=true&"
import script from "./SettingsRoleEditView.vue?vue&type=script&lang=js&"
export * from "./SettingsRoleEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff992722",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff992722')) {
      api.createRecord('ff992722', component.options)
    } else {
      api.reload('ff992722', component.options)
    }
    module.hot.accept("./SettingsRoleEditView.vue?vue&type=template&id=ff992722&scoped=true&", function () {
      api.rerender('ff992722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/role/SettingsRoleEditView.vue"
export default component.exports